import { Sheets } from "common/sheets";
export class Title {
    constructor(pixiContext, sheets) {
        this.sprite = Sheets.animation(pixiContext, sheets, fileName);
        this.sprite.animationSpeed = 0.1;
    }
}
export const fileName = "title";
//# sourceMappingURL=title.js.map